declare namespace $ {

	export class $shm_hitalama_map_book_page extends $mol_view {
		map_id( ): string
	}
	
}

//# sourceMappingURL=page.view.tree.d.ts.map